export default "__VITE_ASSET__38bd4969__"